import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

import { BaseProvider } from './base-provider';

@Injectable()
export class ConsumerMoneyDeviceProvider extends BaseProvider {
	url: any;

	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper
	){
		super();
	}

	getDevices(params){	
	  	this.url = this.globals.dataUrl + 'consumerMoneyDevice/business/' + params.businessId;

    	this.storage.get('loginData').then((loginData) => {
		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(
		    	res => {
		    		this.list = res.Data;
		          	if(typeof params.cb == "function") params.cb(res.Data);
		    	}
		    );   
    	})
  	}		

	addDevice(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'consumerMoneyDevice/' +
	  				 					  '/business/' + params.businessId +
	  				 					  '/device/' + params.device;

			this.storage.get('loginData').then((loginData) => {
				this.http.post(
					this.url,
					params.payment,
					this.httpHelper.configOptionsWithToken(loginData.access_token)
				)
				.map(res=>res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err => {reject(err)}
				);
			});
		});       
	}	   	

	bind(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'consumerMoneyDevice/device/' + params.deviceId + 
											  '/bind/' + params.bind;

			this.storage.get('loginData').then((loginData) => {
				this.http.post(
					this.url,
					null,
					this.httpHelper.configOptionsWithToken(loginData.access_token)
				)
				.map(res=>res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err => {reject(err)}
				);
			});
		});       
	}	
}



// WEBPACK FOOTER //
// ./src/providers/consumer-money-device.ts